import { Link } from "react-router-dom";
import { Users, Calendar, Newspaper, Info, ArrowRight } from "lucide-react";

const links = [
  {
    to: "/foretagsnatverk",
    title: "Nätverksträffar online",
    description: "Träffa andra företagare, säljare och rådgivare digitalt och bygg relationer över tid.",
    Icon: Users,
  },
  {
    to: "/kalender",
    title: "Kalender",
    description: "Se kommande träffar och evenemang. Du deltar via Zoomlänken när det är dags.",
    Icon: Calendar,
  },
  {
    href: "https://www.nyfikenmodellen.se/redovisning",
    title: "NYFIKENmodellen®",
    description: "Utbildningen i konsultativ försäljning för dig som vill sälja genom relationer.",
    Icon: ArrowRight,
  },
  {
    to: "/om-oss",
    title: "Om oss",
    description: "Lär känna oss och varför vi tror på nyfikenhet och långsiktiga relationer.",
    Icon: Info,
  },
];

const QuickLinks = () => {
  return (
    <section className="py-20 md:py-28 px-4 bg-background">
      <div className="container mx-auto">
        <div className="max-w-2xl mb-12">
          <p className="text-sm font-medium uppercase tracking-widest text-accent mb-3">
            Utforska mer
          </p>
          <h2 className="text-2xl md:text-3xl font-semibold text-primary leading-tight">
            Hitta vidare hos oss
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {links.map((link) => {
            const { title, description, Icon } = link;
            const cardContent = (
              <>
                <div className="w-11 h-11 rounded-xl bg-accent/10 flex items-center justify-center mb-4">
                  <Icon className="w-5 h-5 text-accent" />
                </div>
                <h3 className="text-lg font-semibold text-primary mb-1.5">{title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed mb-4">
                  {description}
                </p>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-accent">
                  Läs mer
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
                </span>
              </>
            );
            const className = "group rounded-2xl border border-border/60 bg-card p-6 transition-all hover:border-accent/50 hover:shadow-[var(--shadow-card)] hover:-translate-y-0.5";
            return "href" in link ? (
              <a
                key={link.href}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className={className}
              >
                {cardContent}
              </a>
            ) : (
              <Link
                key={link.to}
                to={link.to}
                className={className}
              >
                {cardContent}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default QuickLinks;
